import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    height: '100%',
    minHeight: 'fit-content',
    maxWidth: 1180,
    margin: '0 auto',
    padding: `${theme.spacing(5)} 26px ${theme.spacing(14)}`,
    width: '100%',
    [theme.breakpoints.down('lg')]: {
      minHeight: 'auto',
      paddingBottom: theme.spacing(5),
    },
    [theme.breakpoints.down('md')]: {
      padding: `${theme.spacing(2.5)} ${theme.spacing(1.5)}`,
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        minHeight: 'auto',
        paddingBottom: theme.spacing(5),
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        padding: `${theme.spacing(2.5)} ${theme.spacing(1.5)}`,
      }),
    },
  },
}));
